<template>
    <AuthenticatedLayout>

        <Toast position="top-center" />

        <div class="flex flex-row w-full align-items-center justify-content-between mt-4">
            <div class="flex flex-row align-items-center">
                <div class="text-4xl mr-4">Grid bot CryptoAI for {{pair.symbol}}</div>
                <div class="mr-4">
                    <a class="text-gray-400" :href="'https://ru.tradingview.com/chart/?symbol=BINANCE%3A'+pair.symbol" target="_blank"><i class="pi pi-external-link" style="font-size: 1.5rem"></i></a>
                </div>
                <div>
                    <div class="" @click="showPairsSelect = !showPairsSelect">
                        <Button v-if="!showPairsSelect" label="" icon="pi pi-chevron-down" iconPos="right" class="p-button-outlined p-button-lg"/>
                        <Button v-else label="" icon="pi pi-chevron-up" iconPos="right" class="p-button-outlined p-button-lg"/>
                    </div>
                </div>
            </div>
            <div class="flex flex-row align-items-center"> <!--justify-content-between-->
                <div class="mr-4 flex flex-row align-items-center">
                    <div class="text-2xl mr-2">Работа:</div><InputSwitch v-model="isBotActive" ></InputSwitch>
                </div>
<!--                <div>-->
<!--                    <SelectButton v-model="selectedBotMode" :options="botModeItems" optionLabel="label" optionValue="value" />-->
<!--                </div>-->
            </div>
        </div>
        <div class="text-gray-500 text-sm ml-2 mb-2">user_bot_id #{{userBotId}}</div>

        <div v-if="showPairsSelect" class="mb-4">
            <PairsTwoTableSelector :items="botPairMenuItems" :compact="true" :select="handleSelectPair"/>
        </div>

<!--        <div class="mb-4">-->
<!--            <Card v-if="true">-->
<!--                <template #content>-->
<!--                    <div class="flex flex-row align-items-center">-->
<!--                        <div class="flex flex-row align-items-center">-->
<!--                            <div class="text-xl mr-2">Лимит USDT для этого типа ботов:</div>-->
<!--                            <div class="mr-2"><InputNumber v-model="availableUsdtByReasonForm" mode="decimal" class="w-10"/></div>-->
<!--                            <div class="mr-4">-->
<!--                                <Button type="button" label="Сохранить" @click="saveAvailableUsdtByReason" />-->
<!--                            </div>-->
<!--                            <div v-if="availableUsdtByReasonForm === null" class="text-gray-500">-->
<!--                                Будет использоваться глобальный лимит USDT-->
<!--                            </div>-->

<!--                        </div>-->
<!--                        <Divider layout="vertical" />-->
<!--                        <div class="flex flex-row align-items-center">-->
<!--                            <Link :href="'/preview/grid/'+userBotId" class="no-underline"><Button label="Настроить бота"/></Link>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </template>-->
<!--            </Card>-->
<!--            <Card v-if="false">-->
<!--                <template #content>-->
<!--                    <div class="flex flex-row align-items-center justify-content-between">-->
<!--                        <div class="flex flex-row align-items-center">-->
<!--                            <div class="text-xl font-bold mr-4">Режим эмуляции!</div>-->
<!--                            <div class="text-xl mr-2">Кошелёк режима эмуляции для этого бота:</div>-->
<!--                            <div class="mr-2"><InputNumber v-model="availableUsdtForDryRunForm" mode="decimal" class="w-10"/></div>-->
<!--                            <div class="mr-2">-->
<!--                                <Button type="button" label="Сохранить" @click="saveAvailableUsdtForDryRun" />-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="flex flex-row align-items-center">-->

<!--                        </div>-->
<!--                    </div>-->
<!--                </template>-->
<!--            </Card>-->
<!--        </div>-->

        <div class="mb-4 flex">

            <div class="mr-4">
                <Card>
                    <template #content>
                        <CandlesDealsGrid
                            :candles="candles"
                            :indicators="indicators"
                            :deals="[...closedDeals, ...openDeals]"
                            :pair="pair.symbol"
                            :width="1000"
                            :timezone="0"
                            :zeroPrice="currentPrice"

                        />
                    </template>
                </Card>
            </div>

            <div class="flex flex-column w-full">
                <Card>
                    <template #content>

                        <p>Тренд: {{currentIndicators.trend_value}}</p>

                        <Divider layout="horizontal" />

                        <Link :href="'/preview/grid/'+userBotId" class="no-underline"><Button label="Редактировать настройки"/></Link>
                    </template>
                </Card>
            </div>


        </div>

        <div class="flex">
            <div class="flex-1">
                <Card class="mb-4">
                    <template #title>
                        Открытые cделки {{pair.symbol}} (примерно ${{sumUsdtInOpenDeals}})
                    </template>
                    <template #content>
                        <OpenDealsTable :deals="openDeals" :currentPrice="currentPrice"></OpenDealsTable>
                    </template>
                </Card>

                <Card>
                    <template #title>
                        Закрытые сделки {{pair.symbol}}
                    </template>
                    <template #content>
                        <ClosedDealsTable :deals="closedDeals"></ClosedDealsTable>
                    </template>
                </Card>

            </div>
            <div class="flex-1 ml-4">
                <Card>
                    <template #title>
                        Логи {{pair.symbol}}
                    </template>
                    <template #content>
                        <div v-if="logs.length > 0">
                            <LogsTable :logs="logs"></LogsTable>
                        </div>
                        <div v-else>
                            <p>Логи отсутствуют.</p>
                        </div>
                    </template>
                </Card>
            </div>
        </div>

    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import InputText from 'primevue/inputtext'
import Card from 'primevue/card'
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { Link } from '@inertiajs/vue2'
import helperMethods from '@/helpers'
import PairsHorisontalMenu from "@/Menu/PairsHorisontalMenu";
import CandlesDealsGrid from "@/Charts/CandlesDealsGrid.vue";
import Toast from 'primevue/toast';
import ProgressSpinner from 'primevue/progressspinner';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import SpinnerWrapper from "@/Components/SpinnerWrapper";
import InputNumber from 'primevue/inputnumber';
import ClosedDealsTable from "@/Tables/ClosedDealsTable";
import LogsTable from "@/Tables/LogsTable";
import OpenDealsTable from "@/Tables/OpenDealsTable";
import SplitButton from 'primevue/splitbutton';
import Dropdown from 'primevue/dropdown';
import SelectButton from 'primevue/selectbutton';
import InputSwitch from 'primevue/inputswitch';
import PairsTwoTableSelector from "@/Menu/PairsTwoTableSelector";
import Divider from "primevue/divider";
import GridBotSettings from "@/Settings/GridBotSettings.vue";
import Dialog from 'primevue/dialog';

export default {
    props: {
        openDeals: Array,
        closedDeals: Array,
        logs: Array,
        availableUsd: String,
        pair: Object,
        candles: Array,
        indicators: Array,
        currentPrice: String,
        botJsonSettings: String,
        availableUsdtByReason: Number,
        availableUsdtByBot: Number,
        availableUsdtForDryRun: Number,
        botPairMenuItems: Array,
        userBotId: Number,
        bot: Object,
        tradingData: Object,
        botSettings: Object,

        flash: Object
    },
    components:{
        GridBotSettings,
        Divider, Dialog,
        OpenDealsTable,
        CandlesDealsGrid,
        // Contenteditable,
        AuthenticatedLayout, DataTable, InputText, Button, Column, Card, Link, Toast, ProgressSpinner, TabView, TabPanel, SpinnerWrapper,
        InputNumber,
        ClosedDealsTable, LogsTable, SplitButton, Dropdown, SelectButton, InputSwitch,
        PairsTwoTableSelector
    },
    data(){
        return {
            botModeItems: [
                {label: 'Эмуляция', value: "dry_run", command: () => {this.changeBotMode('dry_run')}},
                {label: 'Торговля', value: "trade", command: () => {this.changeBotMode('trade')}}
            ],
            selectedBotMode: null,
            isBotActive: null,

            botForm: {
                settings: {}
            }, // редактирование настроек бота
            isSavingBot: false,

            activeTab: 0,
            availableUsdtByReasonForm: null,
            availableUsdtByBotForm: null,
            availableUsdtForDryRunForm: null,

            showPairsSelect: false,

            displaySettings: false,
        }
    },
    mounted() {

        // this.selectedBotMode = this.tradingData.dry_run ? 'dry_run' : 'trade';
        this.selectedBotMode = "trade";

        this.isBotActive = this.tradingData.activated_at !== null;

        // настройки
        this.botForm.settings = this.botSettings;

        // лимиты денег
        this.availableUsdtByReasonForm = this.availableUsdtByReason;
        this.availableUsdtByBotForm = this.availableUsdtByBot;
        this.availableUsdtForDryRunForm = this.availableUsdtForDryRun;
    },
    watch:{
        flash(newFlash, oldFlash){
            //console.log("flash", oldFlash, newFlash);
            if(newFlash.success !== null){
                this.$toast.add({severity:'success', summary: 'Success', detail: newFlash.success, life: 3000});
            }
            if(newFlash.error !== null){
                this.$toast.add({severity:'error', summary: 'Error', detail: newFlash.error, life: 5000});
            }
        },
        selectedBotMode(newMode, oldMode){
            if(oldMode && newMode !== oldMode){
                // console.log("mode", oldMode, newMode);
                this.changeBotMode(newMode);
            }
        },
        isBotActive(newActive, oldActive){ // todo сделать на @changed эвенте компонента
            if(oldActive !== null && newActive !== oldActive){
                // console.log("active", oldActive, newActive);
                this.changeBotActive(newActive);
            }
        }
    },
    computed: {
        sumUsdtInOpenDeals(){
            return Math.round(this.openDeals.reduce((sum, deal) => {
                return sum + parseFloat(deal.value_amount_started);
            }, 0));
        },
        currentIndicators(){
            return this.indicators.slice(-1)[0];
        }
    },
    methods:{
        ...helperMethods,
        // changeBotMode(mode){
        //     this.$inertia.post("/bot/change_mode",
        //         {id: this.botResultData.userBotId, mode: mode},
        //         {preserveScroll: true, only: ['botResultData'],
        //             onBefore: () => confirm('Вы уверены, что хотите изменить режим работы бота? Незакрытые старые сделки, сделанные в режиме эмуляции будут удалены.'),
        //             onSuccess: page => {
        //                 let message = mode === 'dry_run' ? "Бот переведён в режим эмуляции, торговля не будет производиться." : "Бот переведён в режим торговли! Все открытые сделки, сделанные в режиме эмуляции, удалены.";
        //                 this.$toast.add({severity:'success', summary: 'Success', detail: message, life: 5000});
        //             }
        //         },
        //     );
        // },
        changeBotActive(isActive){
            this.$inertia.post("/bot/change_active",
                {id: this.userBotId, set_active: isActive,},
                {preserveScroll: true,
                    onSuccess: page => {
                        let message = isActive ? "Бот запущен" : "Бот остановлен";
                        this.$toast.add({severity:'success', summary: 'Success', detail: message, life: 3000});
                    }
                }
            );
        },
        saveBotSettings(id){
            this.isSavingBot = true;
            this.$inertia.post('/bot/store_settings', {
                id: id,
                settings: this.botForm.settings
            },{
                preserveScroll: true,
                // only: ['botResultData', 'botJsonSettings'],
                onSuccess: (page) => {  this.isSavingBot = false;  }
            })
        },
        resetBotSettings(id){
            this.$inertia.post('/bot/reset_settings', {
                id: id
            },{
                preserveScroll: true,
                // only: ['botResultData', 'botJsonSettings'],
                onSuccess: (page) => {  this.$toast.add({severity:'success', summary: 'Success', detail: "Настройки бота сброшены до дефолтных", life: 3000});  }
            });
        },
        saveAvailableUsdtByReason(){
            this.$inertia.post('/bot/store_wallet_for_group', {
                id: this.userBotId,
                value: this.availableUsdtByReasonForm
            }, {
                preserveScroll: true,
                // only: ['botResultData'],
            })
        },
        saveAvailableUsdtForDryRun(){
            this.$inertia.post('/bot/store_wallet_for_dryrun', {
                id: this.userBotId,
                value: this.availableUsdtForDryRunForm
            }, {
                preserveScroll: true,
                // only: ['botResultData'],
            })
        },
        handleSelectPair(botPairMenuData){
            this.$inertia.visit(`/grid_one/${botPairMenuData.pair_id}`)
        },
        openSettings(){
            this.displaySettings = true;
            console.log(this.displaySettings);
        },
        closeSettings(){
            this.displaySettings = false;
            console.log(this.displaySettings);
        }

    }
}
</script>

